import { Injectable } from '@angular/core';
import { DocGenServiceProxy } from 'app/shared/services/doc-gen-service.proxy';
import { DocumentGenerationResult } from 'app/shared/services/model/doc-gen-service.model';
import { Observable, catchError, map, switchMap, tap, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DocGenService {
    constructor(private _docGenServiceProxy: DocGenServiceProxy) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * generate DocGen document
     */
    generateDocument(
        applicationId: string,
        controlName: string,
        application: { [key: string]: any },
        qualifier: string | undefined = null,
    ): Observable<DocumentGenerationResult> {
        return this._docGenServiceProxy.generatePdf(applicationId, controlName, application, qualifier).pipe(
            map((result: DocumentGenerationResult) => {
                console.log('DocGenService.generateDocument:', result);
                return result;
            }),
            catchError((error) => {
                console.error(error);
                return throwError(() => new Error(error));
            })
        );
    }
}
